import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import {
  AccountPage,
  AlarmsPage,
  ChannelsPage,
  EdmsExplorerPage,
  MachineDetailPage,
  MachinesPage,
  NotificationHistoryPage,
} from './pages';

// EDMS links its alert notifications to /alertgroups/{id}. The Pulse alerts
// page opens a group by its id.
function AlertGroupRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/alarms/${id}`} replace />;
}

function App() {
  return (
    <ProtectedRoute>
      <AppLayout>
        <Routes>
          <Route path='/' element={<Navigate to='/machines' replace />} />
          <Route path='/machines' element={<MachinesPage />} />
          <Route path='/machines/:id' element={<MachineDetailPage />} />
          <Route path='/alarms' element={<AlarmsPage />} />
          <Route path='/alarms/:alarmId' element={<AlarmsPage />} />
          <Route path='/alertgroups/:id' element={<AlertGroupRedirect />} />
          <Route path='/channels' element={<ChannelsPage />} />
          <Route
            path='/notification-history'
            element={<NotificationHistoryPage />}
          />
          <Route path='/edms-explorer' element={<EdmsExplorerPage />} />
          <Route path='/account' element={<AccountPage />} />
          <Route path='*' element={<Navigate to='/machines' replace />} />
        </Routes>
      </AppLayout>
    </ProtectedRoute>
  );
}

export default App;
